import React, { useState, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Select, Button, Modal, message, Tooltip, Icon } from 'antd';
import { Grid } from '@material-ui/core';
import TextEvents from '../TextEvents';
import TextInput from 'app/components/TextInput';
import { styles, useStyles } from './SpecialtyFormStyles';
import SpecialtyTableContainer from 'app/containers/SpecialtyTableContainer';
import { fetchSpecialty, SpecialtyClear, specialtyFilterClear, fetchSpecialtyFilter } from 'app/actions/SpecialtyActions';
import { getSpecialty } from 'app/reducers';
import ApiService from 'app/services/ApiService';
import * as TrainingActions from '../../actions/TrainingActions';
import { employeeById } from 'app/reducers';

const { confirm } = Modal;
const { Option } = Select;
const SelectItem = (name = [], value) => {
    let x = name[value]
    return typeof x !== 'undefined' && x !== null ? x.map((c, i) => <Option key={i}>{c}</Option>) : (x === null ? <Option key={'cargando'}>No existen valores..</Option> : <Option disabled key={'cargando'}>Cargando valores..</Option>);

}

export default function SpecialtyForm(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [collapse, setCollapse] = useState(true);
    const [disabledC, setDisableC] = useState(true);
    const employeeData = useSelector(employeeById);
    const { siteId } = useSelector(state => state.Auth);

    let specialty = useSelector(getSpecialty);

    /* ----------------------------------------------------------- */

    useEffect(() => {
        dispatch(TrainingActions.clear());
        dispatch(TrainingActions.getTrainingSelect(employeeData.employeeId));
    }, [dispatch]);

    const {
        isLoadingTrainingSelect,
        trainingSelect
    } = useSelector(state => state.TrainingReducer);

    const {
        filterData
    } = useSelector(state => state.Specialty)

    const optionName = trainingSelect.filter(x => x.key != "TK0000000002" ).map((item) =>
        <Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>
    );

    const optionSpecialtyNames = filterData.length === 0 ? [] : filterData[0].specialtyNames.filter(x => props.names.includes(x.idTraining)).map((item) =>
    <Select.Option key={item.name} value={item.name}>{item.name}</Select.Option>
    )

    const onSelectNames = (Training) => {
            setDisableC(Training.length === 1 ? false : true)
            props.setNames(Training);
           
           // props.setName(props.name.filter(x => filterData[0].specialtyNames.filter(y => Training.includes(y.idTraining)).map(z => z.name).includes(x) ) )
           
        
    }
   
    /* ----------------------------------------------------------- */

    const data = {
        specialtyName: props.name.join('|'),
        sortColumn: Object.keys(props.sorter).length > 0 ? props.sorter.field : '',
        sortDir: Object.keys(props.sorter).length > 0 ? props.sorter.order === "ascend" ? "ASC" : "DESC" : '',
        offset: (0 * props.pagination.pageSize),
        limit: props.pagination.pageSize,
        training: props.names.join(","),
        subDirectionOrigin: employeeData.idSubdirection,
        employeeId : employeeData.employeeId
    }

    const submit = () => {
            ApiService.setSpecialty({ idSpecialty: props.idSpecialty, specialtyName: props.nameSpecialty, specialtyDescription: '', training: props.names.length > 0 ? props.names[0] : "0000000" , subDirectionOrigin: employeeData.idSubdirection }, props.idSpecialty > 0 ? 'PUT' : 'POST').then(
         
            res => {
                props.isVisibleForm(false)
                res.idSpecialty == -1 ? message.error(`La especialidad ${props.nameSpecialty} ya existe para esta especialidad`) : message.success(`La especialidad ${props.nameSpecialty} se guardó correctamente!`);
                dispatch(specialtyFilterClear());
                dispatch(fetchSpecialtyFilter({
                    training: props.names !== undefined ? props.names.join(',') : '', 
                    subDirectionOrigin: employeeData.idSubdirection,
                    employeeId : employeeData.employeeId
                }));
                search();
                props.setNameSpecialty('');

            },
            error => {
                message.error('Ocurrió un error intente mas tarde.');
            }
        );
    }
    const search = () => {
        dispatch(SpecialtyClear());
        dispatch(fetchSpecialty(data));
        props.setFormData(data);
    }

    const newSpecialty = () => {
        props.setIdSpecialty(0);
        props.setNameSpecialty('');
        props.isVisibleForm(true);
    }

    const toExport = async () => {
        await ApiService.getSpecialtyExport(data)
            .then(
                result => {
                    const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    downloadFile(blob, "BandejaEspecialidades.xlsx");
                },
                error => {
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    }

    const downloadFile = (blob, fileName) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.append(link);
        link.click();
        link.remove();
        window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
    };

    const size = (text, idSpecialty, property = "", training) => {
        var ret = "";
        if (property != "") {
            var obj = specialty.find(x => x.specialtyName === text && x.training === training[0]);
            if (obj != undefined) {
                if (idSpecialty === undefined) {
                    ret = " Ya esta asignado";
                } else {
                    if (idSpecialty != obj.idSpecialty) ret = " Ya esta asignado";
                }
            }
        }
        return ret;
    }

    const csize = (text, idSpecialty, property = "", training) => {
        var ret = "grey";
        if (property != "") {
            var obj = specialty.find(x => x.specialtyName === text && x.training === training[0]);
            if (obj != undefined) {
                if (idSpecialty === undefined) {
                    ret = "red";
                } else {
                    if (idSpecialty != obj.idSpecialty) ret = "red";
                }
            }

        }
        return ret;
    }


    const handleChange = (value, i, key) => {
        const array = [];
        i.map(i => {
            array.push(i.props.children);
            return array;
        })
        if (i.length === 0) {
            switch (key) {
                case 'specialtyName':
                    props.setName([])
                    break;
                default:
                    break;
            }
        }

        // eslint-disable-next-line array-callback-return
        i.map(() => {
            if (key === 'specialtyName') {
                props.setName(array)
            }
        })
    }

    return (
        <div>
            <SpecialtyTableContainer>
                {(params) => {
                    return (
                        <div>
                            <div hidden={collapse}>
                            <Grid container spacing={1} direction="row">
                                <Grid item xs={6}>
                                    <TextEvents
                                        text='Tipo de capacitación:'
                                        color="darker"
                                        size='label'
                                        weight="medium"
                                    />
                                    <Select
                                        mode="multiple"
                                        loading={isLoadingTrainingSelect}
                                        placeholder="[Selecionar tipo de capacitación]"
                                        showSearch
                                        value={props.names}
                                        onChange={onSelectNames}
                                        style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                        optionFilterProp="Children"
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {optionName}
                                    </Select>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextEvents
                                        text='Nombre:'
                                        color="darker"
                                        size='label'
                                        weight="medium"
                                    />
                                    <Select
                                        mode="multiple"
                                        showSearch
                                        value={props.name}
                                        optionFilterProp="children"
                                        style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                        placeholder="[Seleccionar nombre]"
                                        //disabled={disabledC}
                                        onChange={(v, i) => handleChange(v, i, 'specialtyName')}
                                    >
                                        {
                                            optionSpecialtyNames
                                           
                                        }
                                    </Select>
                                </Grid>
                            </Grid>
                            </div>
                            <div className={classes.container} style={styles.baseVerticalMargin}>
                                {
                                    collapse ?
                                        <Tooltip title={"Mostrar filtro"}>
                                            <Button
                                                className={classes.button}
                                                variant="contained"
                                                type="link"
                                                onClick={() => setCollapse(false)}
                                            >
                                                <Icon type="down" />
                                            </Button>
                                        </Tooltip> :
                                        <Tooltip title={"Ocultar filtro"}>
                                            <Button
                                                className={classes.button}
                                                variant="contained"
                                                type="link"
                                                onClick={() => setCollapse(true)}
                                            >
                                                <Icon type="up" />
                                            </Button>
                                        </Tooltip>
                                }

                                <Button
                                    className={classes.button}
                                    variant="contained"
                                    type="primary"
                                    //disabled={!filter.listNames.length}
                                    onClick={() => search()}
                                >
                                    Buscar
                                </Button>
                                <Button
                                    className={classes.button}
                                    variant="contained"
                                    type="primary"
                                    //disabled={!filter.listNames.length}
                                   // disabled={disabledC}
                                    onClick={toExport}
                                >
                                    Exportar
                                </Button>
                                {
                                    siteId === 'HUB' ?
                                        <Button
                                            className={classes.button}
                                            variant="contained"
                                            type="primary"
                                            disabled={disabledC}
                                            onClick={newSpecialty}
                                        >
                                            Nuevo
                                        </Button> : null
                                }
                            </div>
                        </div>
                    )
                }}
            </SpecialtyTableContainer>
            <Modal
                destroyOnClose={true}
                onCancel={() => props.isVisibleForm(false)}
                visible={props.visibleForm}
                title={<TextEvents
                    text={props.idSpecialty > 0 ? 'Editar Especialidad' : 'Nueva Especialidad'}
                    color='cotemar'
                    size='label'
                    weight='bold'
                />}
                width={'650px'}
                centered={true}
                footer={[
                    <Button key="back" type="danger" ghost onClick={() => props.isVisibleForm(false)}>
                        Cancelar
                    </Button>,
                    siteId === 'HUB' ?
                        <Button disabled={props.nameSpecialty === '' || (props.idSpecialty > 0 && props.nameSpecialty === props.row.specialtyName) || (specialty.filter(x => x.specialtyName === props.nameSpecialty && x.idSpecialty !== props.idSpecialty && x.training == props.names).length > 0)} key="submit" type="primary" loading={false} onClick={() => submit()}>
                            Confirmar
                        </Button> : null,
                ]}
            >
                <Grid container direction="row">
                    <Grid item xs={12}>
                        <TextInput
                            disabled={siteId !== 'HUB'}
                            value={props.nameSpecialty}
                            setValue={props.setNameSpecialty}
                            text='Nombre de la Especialidad: '
                            color='darker'
                            size='label'
                            weight='medium'
                            tamano={size(props.nameSpecialty, props.idSpecialty, "names", props.names)}
                            tcolor={csize(props.nameSpecialty, props.idSpecialty, "names", props.names)}
                            mode='input'
                            placeholder='Nombre'
                        />
                    </Grid>
                </Grid>
            </Modal>
        </div>
    );
}